<template>
    <div v-if="flexi_reschedule_id" id="reschedule-banner" class="d-flex justify-content-center mx-auto">
        <div class="row mx-0 my-1 w-100">
            <div class="col-2 pl-1 pr-0 d-flex justify-content-center">
                <img src="https://dr4y4dqumhrhn.cloudfront.net/soma_calendar_new.png">
            </div>
            <div class="col-8 px-0 d-flex flex-column justify-content-center">
                <div id="reschedule-msg-bg" class="text-center">Flexi Reschedule</div>
                <div id="reschedule-msg-sm" class="text-center">This booking is under Flexi Reschedule Policy.</div>
            </div>
            <div class="col-2 px-0 d-flex justify-content-center">
                <img src="https://dr4y4dqumhrhn.cloudfront.net/green_tick_new.png">
            </div>
        </div>
    </div>
    <div class="carouselbar mx-auto" v-if="banner_images.length">
        <div :key="banner_images.length" id="homeCarouse" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" id="carouselInner">
                <a v-for="(item, index) in banner_images" :key="index" href="javascript:;"
                    class="carousel-item" :class="{ active: index === 0 }" :data-interval="item.type === 'video' ? 15000 : 5000">
                    <img v-if="item.type === 'image'" :src="item.url" class="d-block w-100" :alt="item.title">
                    <div v-else-if="item.type === 'video'" class="video-wrapper" @click="toggleVideo">
                        <video :src="item.url" class="d-block w-100" autoplay muted loop playsinline ref="video"></video>
                        <div class="video-play-btn" v-show="showVideoPlayBtn">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </div>
                    </div>
                </a>
            </div>

            <button class="carousel-control-prev" type="button" data-target="#homeCarouse" data-slide="prev">
                <span class="visually-hidden">Previous</span>
                <svg class="ccarroricon"><use xlink:href="#chevron-left-angle"></use></svg>
            </button>
            <button class="carousel-control-next" type="button" data-target="#homeCarouse" data-slide="next">
                <span class="visually-hidden">Next</span>
                <svg class="ccarroricon"><use xlink:href="#chevron-right"></use></svg>
            </button>
        </div>
    </div>
    <Teleport to=".navbar">
        <transition-group name="toast" tag="div" class="toast-wrapper" :style="{ marginTop: flexi_reschedule_id ? '60px' : '5px' }">
            <div class="toast-item" v-for="(toast, index) in toasts" :key="toast.id" v-html="toast.message"></div>
        </transition-group>
    </Teleport>
    <div id="main" class="d-flex flex-column align-items-start justify-content-start mx-auto" :style="mainStyle">
        <div class="py-4 w-100">
            <div class="row mx-0 w-100 mt-2">
                <div class="col-12 px-0">
                    <div id="select-outlet-outer-container">
                        <div id="select-outlet-container" class="d-flex">
                            <img src="https://dr4y4dqumhrhn.cloudfront.net/outlet_light.png">
                            <select id="select-outlet" v-model="outlet" class="w-100 ml-2" @change="on_outlet_change">
                                <option v-for="(outlet, index) in outlet_options" :value="outlet.name" :key="index">{{ outlet.shop_full_name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-2" v-if="outlet_info.address">
                <div class="col-12 px-0">
                    <div id="address-outer-container">
                        <div id="address-container" class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <svg class="waze-btn" @click="openWaze()" width="36" height="36" fill="#FECF6B" viewBox="0 0 24 24" style="cursor: pointer;">
                                    <path d="m21.97,10.99h0c0-2.38-.94-4.67-2.63-6.35-1.69-1.7-3.94-2.64-6.33-2.64-2.74,0-5.29,1.22-7.03,3.42-1.26,1.59-1.95,3.56-1.94,5.59v1.49c0,.76-.6,1.51-1.6,1.51-.17,0-.32.11-.37.27-.19.62.57,2,1.65,3.09.68.7,1.48,1.27,2.36,1.71-.24,1.36.67,2.65,2.03,2.89.14.02.28.04.43.04,1.19,0,2.21-.83,2.44-2h2.09c.28,1.41,1.74,2.38,3.31,1.85.68-.23,1.22-.77,1.47-1.45.23-.65.2-1.28-.01-1.83.55-.35,1.06-.77,1.52-1.23,1.69-1.69,2.63-3.97,2.62-6.36Zm-8.96,8.02h-2.04c-.23-1.17-1.25-2.01-2.44-2.01-.85,0-1.64.43-2.1,1.14v.02c-.75-.39-1.43-.89-2.01-1.49-.7-.71-1.08-1.36-1.26-1.77.46-.11.87-.35,1.19-.7.43-.46.67-1.08.66-1.71v-1.49c0-1.77.59-3.5,1.67-4.9,1.55-2,3.85-3.11,6.31-3.11,2.12,0,4.12.83,5.63,2.35,1.5,1.5,2.34,3.53,2.34,5.65,0,2.14-.83,4.14-2.33,5.66-1.47,1.48-3.49,2.36-5.63,2.36Z"/>
                                    <path d="m12,9c0-.55-.45-1-1-1s-1,.45-1,1,.45,1,1,1,1-.45,1-1Z"/>
                                    <path d="m17.37,12.04c-.07-.03-.14-.05-.21-.05h-.01c-.19,0-.36.11-.44.28-.49,1.05-1.54,1.71-2.7,1.72-1.16,0-2.21-.67-2.7-1.72-.08-.17-.26-.28-.45-.28-.27,0-.5.22-.5.5,0,.07.02.14.05.21.66,1.4,2.06,2.29,3.61,2.29,1.55,0,2.95-.9,3.61-2.29.12-.25,0-.54-.24-.66Z"/>
                                    <path d="m16.99,8c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1h0c0-.55-.45-1-1-1Z"/>
                                </svg>
                                <div class="ml-2 address-text">{{ outlet_info.address }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-2">
                <div class="col-4 pl-0 pr-1">
                    <div id="session-outer-container">
                        <div id="session-container" class="row mx-0 d-flex justify-content-center align-items-center">
                            <div id="minutes-display" class="col-8 px-0 d-flex justify-content-center">
                                <img src="https://dr4y4dqumhrhn.cloudfront.net/duration_light.png">
                                <div class="d-flex flex-column justify-content-center align-items-center ml-2">
                                    <div>{{ session }}</div>
                                    <div id="minutes">mins</div>
                                </div>
                            </div>
                            <div v-if="session == 120" class="col-3 px-0 d-flex justify-content-center align-items-center btn-adjust-session" @click="adjust_session('reset')">&minus;</div>
                            <div v-else class="col-3 px-0 d-flex justify-content-center align-items-center btn-adjust-session" @click="adjust_session('add')">&plus;</div>
                        </div>
                    </div>
                </div>
                <div class="col-8 px-0">
                    <div id="date-outer-container">
                        <div id="date-container" class="d-flex justify-content-end px-2">
                            <input
                                id="booking_date_datepicker"
                                type="text"
                                ref="datepickerInput"
                                :value="formatted_date"
                                readonly
                            >
                            <img id="booking-date" src="https://dr4y4dqumhrhn.cloudfront.net/calendar.png" @click="datepicker_icon_on_click">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-2">
                <div class="col-3 pl-0 pr-1">
                    <div id="therapist-gender-outer-container" v-if="therapist_gender_mode == 'auto'" @click="toggle_therapist_gender_mode('specific')">
                        <div id="therapist-gender-container" class="row mx-0 d-flex justify-content-center align-items-center">
                            <img id="therapist-gender-female" class="px-0" src="https://dr4y4dqumhrhn.cloudfront.net/therapist_female.png">
                            <img id="therapist-gender-male" class="px-0" src="https://dr4y4dqumhrhn.cloudfront.net/therapist_male.png">
                        </div>
                    </div>
                    <div id="therapist-gender-outer-container" v-else @click="toggle_therapist_gender_mode('auto')">
                        <div id="therapist-gender-container" class="row mx-0 d-flex justify-content-center align-items-center">
                            <img id="therapist-gender-back" class="px-0" src="https://dr4y4dqumhrhn.cloudfront.net/therapist_back.png">
                        </div>
                    </div>
                </div>
                <div class="col-9 px-0">
                    <div id="pax-outer-container">
                        <div id="pax-track-outer" class="d-flex" :style="{ transform: therapist_gender_mode == 'auto' ? 'translateX(0%)' : 'translateX(-50%)' }">
                            <div class="pax-track-inner" :style="therapist_gender_mode == 'specific' ? { paddingRight: '2%' } : {}">
                                <div id="pax-container-auto" class="row mx-0 d-flex justify-content-center align-items-center">
                                    <div id="label-any-therapist" class="col-6 px-0 d-flex align-items-center">Any Therapist Gender (More Slots)</div>
                                    <div class="col-1 px-0 d-flex justify-content-center align-items-center btn-adjust-pax" @click="adjust_pax('minus')">&minus;</div>
                                    <div id="pax-display" class="col-3 px-0 mx-1 d-flex justify-content-center">
                                        <img src="https://dr4y4dqumhrhn.cloudfront.net/pax_light.png">
                                        <div class="ml-2 d-flex align-items-center">
                                            X {{ pax }}
                                        </div>
                                    </div>
                                    <div class="col-1 px-0 d-flex justify-content-center align-items-center btn-adjust-pax" @click="adjust_pax('add')">&plus;</div>
                                </div>
                            </div>
                            <div class="pax-track-inner" :style="therapist_gender_mode == 'auto' ? { paddingLeft: '2%' } : {}">
                                <div id="pax-container-specific" class="row mx-0 d-flex justify-content-center align-items-center">
                                    <div class="col-6 px-0"
                                        :style="female_pax > 0 ? { backgroundColor: '#FE0072', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px'} : {}">
                                        <div class="row mx-0 d-flex justify-content-center align-items-center">
                                            <div class="col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax" @click="adjust_female_pax('minus')">&minus;</div>
                                            <div id="female-pax-display" class="col-6 px-0 mx-1 d-flex justify-content-center">
                                                <img src="https://dr4y4dqumhrhn.cloudfront.net/girl%20brown.png">
                                                <div class="ml-2 d-flex align-items-center">
                                                    X {{ female_pax }}
                                                </div>
                                            </div>
                                            <div class="col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax" @click="adjust_female_pax('add')">&plus;</div>
                                        </div>
                                    </div>
                                    <div id="male-pax-container" class="col-6 px-0"
                                        :style="male_pax > 0 ? { backgroundColor: '#012AFF', borderTopRightRadius: '8px', borderBottomRightRadius: '8px'} : {}">
                                        <div class="row mx-0 d-flex justify-content-center align-items-center">
                                            <div class="col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax" @click="adjust_male_pax('minus')">&minus;</div>
                                            <div id="male-pax-display" class="col-6 px-0 mx-1 d-flex justify-content-center">
                                                <img src="https://dr4y4dqumhrhn.cloudfront.net/man%20brown.png">
                                                <div class="ml-2 d-flex align-items-center">
                                                    X {{ male_pax }}
                                                </div>
                                            </div>
                                            <div class="col-2 px-0 d-flex justify-content-center align-items-center btn-adjust-pax" @click="adjust_male_pax('add')">&plus;</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-2">
                <div class="col-12 px-0">
                    <ExperienceControl v-model="experience_tier"></ExperienceControl>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-2">
                <button id="btn-view-time-now" @click="get_online_booking_available_timeslot()">
                    <img id="view-time-now" class="px-0" src="https://dr4y4dqumhrhn.cloudfront.net/view_time_now.png">
                </button>
            </div>
            <div class="row mx-0 w-100 mt-2" v-if="display_timeslots">
                <div class="col-3 p-1" v-for="(slot, index) in available_timeslots" :key="slot.time">
                    <div class="timeslot d-flex flex-column p-2" :class="{ 'timeslot-active': active_slot === index, 'timeslot-unavailable': !slot.active }" @click="timeslot_on_click(slot, index)">
                        <div class="d-flex justify-content-center time">{{ slot.time.slice(0, -3) }}</div>
                        <div class="d-flex justify-content-end" :class="get_discount_percentage(slot.discount)">{{ slot.discount }}%</div>
                        <div class="d-flex justify-content-end" :class="get_discount_off(slot.discount)">OFF</div>
                    </div>
                </div>
            </div>
            <div id="floating-more-discount-row" class="row mx-0 w-100 mt-4" @click="scrollToMoreDiscount()" v-if="show_floating_more_discount && display_timeslots && (nearby_outlet.length > 0 || nearby_outlet_integrated.length > 0 || next_day || next_week)">
                <div id="more-discount" class="col-8">
                    MORE DISCOUNT!
                </div>
                <img id="img-nearby-outlet" src="https://dr4y4dqumhrhn.cloudfront.net/soma_to_soma.webp">
            </div>
            <div id="more-discount-row" class="row mx-0 w-100 mt-4" v-if="display_timeslots && (nearby_outlet.length > 0 || nearby_outlet_integrated.length > 0 || next_day || next_week)">
                <div id="more-discount" class="col-8">
                    MORE DISCOUNT!
                </div>
                <img id="img-nearby-outlet" src="https://dr4y4dqumhrhn.cloudfront.net/soma_to_soma.webp">
            </div>
            <div class="row mx-0 w-100" v-if="display_timeslots && nearby_outlet.length > 0" v-for="(n, index) in nearby_outlet">
                <div class="suggested-outlet-row px-0 my-2">
                    <div class="nearby-outlet-title col-12 px-3" v-if="index == 0">Nearby Outlet</div>
                    <div class="nearby-outlet-content row mx-0 py-2" :class="{'nearby-outlet-content-no-title': index != 0}">
                        <div class="col-6 flex flex-column pl-4 pr-0">
                            <span class="shop-full-name">{{ n.shop_full_name }}</span>
                            <button class="btn-view-now" @click="nearby_outlet_view_now_onclick(n)">VIEW NOW</button>
                        </div>
                        <div class="col-6 pl-0 pr-4 row mx-0">
                            <div class="col-5 px-0 flex flex-column justify-content-center align-items-center">
                                <div class="distant">{{ n.distant }}</div>
                                <div class="distant-label flex justify-content-center">
                                    KM Away
                                </div>
                            </div>
                            <div class="col-7 px-0 flex justify-content-center">
                                <div class="flex flex-column">
                                    <div class="flex justify-content-center up-to-label">UP TO</div>
                                    <div class="flex justify-content-center highest-discount">{{ n.highest_discount }}</div>
                                </div>
                                <div class="highest-discount-label flex flex-column justify-content-center">
                                    <span>%</span>
                                    <span>off</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100" v-if="display_timeslots && nearby_outlet_integrated.length > 0" v-for="(n, index) in nearby_outlet_integrated">
                <div class="suggested-outlet-row px-0 my-2">
                    <div class="nearby-outlet-title col-12 px-3 flex justify-content-between align-items-center" v-if="index == 0">
                        <span>Other Brands</span>
                        <img src="https://dr4y4dqumhrhn.cloudfront.net/broccoli_partner.png">
                        <img src="https://dr4y4dqumhrhn.cloudfront.net/hl_purple.png">
                    </div>
                    <div class="nearby-outlet-content row mx-0 py-2" :class="{'nearby-outlet-content-no-title': index != 0}">
                        <div class="col-6 flex flex-column pl-4 pr-0">
                            <span class="shop-full-name">{{ n.shop_full_name }}</span>
                            <button class="btn-view-now" @click="nearby_outlet_view_now_onclick(n)">VIEW NOW</button>
                        </div>
                        <div class="col-6 pl-0 pr-4 row mx-0">
                            <div class="col-5 px-0 flex flex-column justify-content-center align-items-center">
                                <div class="distant">{{ n.distant }}</div>
                                <div class="distant-label flex justify-content-center">
                                    KM Away
                                </div>
                            </div>
                            <div class="col-7 px-0 flex justify-content-center">
                                <div class="flex flex-column">
                                    <div class="flex justify-content-center up-to-label">UP TO</div>
                                    <div class="flex justify-content-center highest-discount">{{ n.highest_discount }}</div>
                                </div>
                                <div class="highest-discount-label flex flex-column justify-content-center">
                                    <span>%</span>
                                    <span>off</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100" v-if="display_timeslots && next_day">
                <div class="suggested-outlet-row px-0 my-2">
                    <div id="same-outlet-title-nd" class="col-12 px-3">Same Outlet | New Date</div>
                    <div class="same-outlet-content row mx-0 py-2">
                        <div class="col-6 flex flex-column pl-4 pr-0">
                            <span class="shop-full-name">Next Day</span>
                            <span class="shop-full-name">{{ pretty_date(next_day.booking_date) }}</span>
                            <button class="btn-view-now" @click="next_day_next_week_view_now_onclick(next_day.booking_date)">VIEW NOW</button>
                        </div>
                        <div class="col-6 pl-0 pr-4 row mx-0">
                            <div class="col-5"></div>
                            <div class="col-7 px-0 flex justify-content-center">
                                <div class="flex flex-column">
                                    <div class="flex justify-content-center up-to-label">UP TO</div>
                                    <div class="flex justify-content-center highest-discount">{{ next_day.highest_discount }}</div>
                                </div>
                                <div class="highest-discount-label flex flex-column justify-content-center">
                                    <span>%</span>
                                    <span>off</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mx-0 w-100" v-if="display_timeslots && next_week">
                <div class="suggested-outlet-row px-0 my-2">
                    <div id="same-outlet-title-nw" class="col-12 px-3" v-if="!next_day">Same Outlet | New Date</div>
                    <div class="same-outlet-content same-outlet-content-nw row mx-0 py-2" :class="{'nearby-outlet-content-no-title': next_day}">
                        <div class="col-6 flex flex-column pl-4 pr-0">
                            <span class="shop-full-name">Next Week</span>
                            <span class="shop-full-name">{{ pretty_date(next_week.booking_date) }}</span>
                            <button class="btn-view-now" @click="next_day_next_week_view_now_onclick(next_week.booking_date)">VIEW NOW</button>
                        </div>
                        <div class="col-6 pl-0 pr-4 row mx-0">
                            <div class="col-5"></div>
                            <div class="col-7 px-0 flex justify-content-center">
                                <div class="flex flex-column">
                                    <div class="flex justify-content-center up-to-label">UP TO</div>
                                    <div class="flex justify-content-center highest-discount">{{ next_week.highest_discount }}</div>
                                </div>
                                <div class="highest-discount-label flex flex-column justify-content-center">
                                    <span>%</span>
                                    <span>off</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="suggetion-div-end" v-if="display_timeslots"></div>
            <div class="row mx-0 w-100 mt-2">
                <img class="px-0" src="https://dr4y4dqumhrhn.cloudfront.net/service_banner_2_soma.webp">
            </div>
            <div class="row mx-0 w-100 mt-2 booking-info px-3" v-if="active_slot !== undefined">
                <div class="col-12 d-flex align-items-center">
                    <img class="booking-icon" src="https://dr4y4dqumhrhn.cloudfront.net/outlet_dark.png">
                    <div class="ml-4">{{ outlet_info.shop_full_name }}</div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-2 booking-info px-3" v-if="active_slot !== undefined">
                <div class="col-6 d-flex align-items-center">
                    <img class="booking-icon" src="https://dr4y4dqumhrhn.cloudfront.net/duration_dark.png">
                    <div class="ml-4">{{ session }} mins</div>
                </div>
                <div class="col-6 d-flex align-items-center">
                    <img class="booking-icon" src="https://dr4y4dqumhrhn.cloudfront.net/pax_dark.png">
                    <div class="ml-4">{{ this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax }} pax</div>
                </div>
            </div>
            <div class="row mx-0 w-100 mt-4 booking-info px-3 d-flex flex-column" v-if="active_slot !== undefined">
                <div class="col-12">{{ formatted_date }}</div>
                <div class="col-12">{{ format_checkout_time() }}</div>
            </div>
            <div class="row mx-0 w-100 mt-4 booking-info px-3" v-if="active_slot !== undefined">
                <div class="col-7">{{ get_session_price() }} x {{ this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax }} Pax</div>
                <div class="col-5 d-flex justify-content-end">{{ get_total_before_discount() }}</div>
            </div>
            <div id="discount-info" class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined && this.available_timeslots[this.active_slot].discount">
                <div class="col-7">{{ this.available_timeslots[this.active_slot].discount }}% off</div>
                <div class="col-5 d-flex justify-content-end">- {{ get_total_discount() }}</div>
            </div>
            <div class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined">
                <div class="col-7" v-if="has_sst">SST 8%</div>
                <div class="col-7" v-else>SST 0%</div>
                <div class="col-5 d-flex justify-content-end">{{ get_total_tax_without_flexi_reschedule_fee() }}</div>
            </div>
            <div class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined && flexi_reschedule_id">
                <div class="col-7">Subtotal</div>
                <div class="col-5 d-flex justify-content-end">{{ get_subtotal() }}</div>
            </div>
            <div id="previously-paid-info" class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined && flexi_reschedule_id">
                <div class="col-7">Treatment Paid</div>
                <div class="col-5 d-flex justify-content-end">- {{ get_previously_paid() }}</div>
            </div>
            <div class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined && flexi_reschedule_id">
                <div class="col-7">To Top Up</div>
                <div class="col-5 d-flex justify-content-end">{{ get_to_top_up() }}</div>
            </div>
            <div class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined && flexi_reschedule_id">
                <div class="col-7">Flexi Reschedule</div>
                <div class="col-5 d-flex justify-content-end">{{ get_total_flexi_reschedule_fee() }}</div>
            </div>
            <div class="row mx-0 w-100 booking-info px-3" v-if="active_slot !== undefined">
                <div class="col-7">Total</div>
                <div id="booking-total" class="col-5 d-flex justify-content-end">{{ get_total_after_discount_and_tax() }}</div>
            </div>
            <div class="row mx-0 w-100 mt-2 mb-16" @click="checkout_now_onclick()" v-if="active_slot !== undefined">
                <img id="checkout-now" src="https://dr4y4dqumhrhn.cloudfront.net/check_out_now.png">
            </div>
            <div id="page-bottom"></div>
        </div>
        <div class="popup-overlay" v-if="display_checkout_confirmation">
            <div class="popup d-flex flex-column align-items-center">
                <img src="https://dr4y4dqumhrhn.cloudfront.net/popup_v3.png">
                <div id="popup-btn-row" class="d-flex row mx-0 w-75">
                    <div class="col-6 pl-0 pr-1 popup-btn" @click="reconsider_onclick()">
                        <img src="https://dr4y4dqumhrhn.cloudfront.net/reconsider.png">
                    </div>
                    <div class="col-6 pl-1 pr-0">
                        <button id="btn-ok-lets-go" @click="ok_lets_go_onclick()">
                            <img src="https://dr4y4dqumhrhn.cloudfront.net/ok_lets_go.png">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import { get_tracking_ids } from '../utils/tracking';
import ExperienceControl from './components/ExperienceControl/ExperienceControl.vue';

export default {
    components: { ExperienceControl },
    props: [],
    computed: {
        formatted_date() {
            if (!this.booking_date) return ""
            return new Intl.DateTimeFormat("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric",
                year: "numeric"
            }).format(new Date(this.booking_date))
        },
        mainStyle() {
            return {
                marginTop: this.banner_images.length ? '-47px' : '0'
            };
        }
    },
    watch: {
        pax(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();
        },
        female_pax(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();
        },
        male_pax(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();
        },
        session(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();
        },
        booking_date(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();

            // Track Date Selection
            if (new_value && old_value) {
                const dateStr = new_value.toLocaleDateString("en-CA");
                const dayOfWeek = new_value.toLocaleDateString("en-US", { weekday: "long" });
                const isWeekend = new_value.getDay() === 0 || new_value.getDay() === 6;

                window.dataLayer.push({
                    event: 'date_selection',
                    booking_date: dateStr,
                    day_of_week: dayOfWeek,
                    is_weekend: isWeekend,
                    outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || 'unknown',
                    session_duration: this.session,
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    user_id: this.hashed_user_id,
                });
            }
        },
        therapist_gender_mode(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();
        },
        experience_tier(new_value, old_value) {
            this.clear_active_slots_and_hide_timeslots();
        },
    },
    data() {
        return {
            hashed_user_id: undefined,
            display_timeslots: false,
            outlet_options: [],
            outlet: "",
            min_date: new Date(),
            max_date: new Date(new Date().setDate(new Date().getDate() + 30)),
            booking_date: new Date(),
            session: 60,
            pax: 1,
            female_pax: 1,
            male_pax: 0,
            outlet_info: {},
            timeslots: [
                {
                    time: "10:00:00",
                    discount: 0,
                },
                {
                    time: "10:30:00",
                    discount: 0,
                },
                {
                    time: "11:00:00",
                    discount: 0,
                },
                {
                    time: "11:30:00",
                    discount: 0,
                },
                {
                    time: "12:00:00",
                    discount: 0,
                },
                {
                    time: "12:30:00",
                    discount: 0,
                },
                {
                    time: "13:00:00",
                    discount: 0,
                },
                {
                    time: "13:30:00",
                    discount: 0,
                },
                {
                    time: "14:00:00",
                    discount: 0,
                },
                {
                    time: "14:30:00",
                    discount: 0,
                },
                {
                    time: "15:00:00",
                    discount: 0,
                },
                {
                    time: "15:30:00",
                    discount: 0,
                },
                {
                    time: "16:00:00",
                    discount: 0,
                },
                {
                    time: "16:30:00",
                    discount: 0,
                },
                {
                    time: "17:00:00",
                    discount: 0,
                },
                {
                    time: "17:30:00",
                    discount: 0,
                },
                {
                    time: "18:00:00",
                    discount: 0,
                },
                {
                    time: "18:30:00",
                    discount: 0,
                },
                {
                    time: "19:00:00",
                    discount: 0,
                },
                {
                    time: "19:30:00",
                    discount: 0,
                },
                {
                    time: "20:00:00",
                    discount: 0,
                },
                {
                    time: "20:30:00",
                    discount: 0,
                },
                {
                    time: "21:00:00",
                    discount: 0,
                },
                {
                    time: "21:30:00",
                    discount: 0,
                },
                {
                    time: "22:00:00",
                    discount: 0,
                },
                {
                    time: "22:30:00",
                    discount: 0,
                },
                {
                    time: "23:00:00",
                    discount: 0,
                },
                {
                    time: "23:30:00",
                    discount: 0,
                },
            ],
            available_timeslots: [],
            nearby_outlet: [],
            nearby_outlet_integrated: [],
            next_day: undefined,
            next_week: undefined,
            active_slot: undefined,
            price: 999,
            has_sst: false,
            display_checkout_confirmation: false,
            timeslot_selected: false,
            timeslot_selected_time: null,
            datepickerInstance: null,
            banner_images: [],
            showVideoPlayBtn: false,
            view_time_onload: false,
            show_floating_more_discount: true,
            scroll_to_timeslots: true,
            toasts: [],
            toast_id: 0,
            flexi_reschedule_id: undefined,
            total_flexi_reschedule_fee: 999,
            previously_paid: 0,
            previously_paid_with_tax: 0,
            therapist_gender_mode: "auto",
            experience_tier: 0,
            experience_map: {
                0: "Standard",
                1: "Deluxe",
                2: "Ultra"
            }
        }
    },
    methods: {
        datepicker_icon_on_click() {
            if (this.datepickerInstance) {
                this.datepickerInstance.show();
            }
        },
        initDatepicker() {
            const params = new URLSearchParams(window.location.search);
            const date_str = params.get("date");
            const pax = params.get("pax");
            const female_pax = params.get("female_pax");
            const male_pax = params.get("male_pax");
            const session = params.get("session");
            const experience_tier = params.get("tier");

            const pax_regex = /^[1-4]$/;

            if (female_pax || male_pax) {
                this.therapist_gender_mode = "specific";
                if (pax_regex.test(female_pax)) {
                    this.female_pax = parseInt(female_pax);
                }
                if (pax_regex.test(male_pax)) {
                    this.male_pax = parseInt(male_pax);
                }
                if ((this.female_pax == 0 && this.male_pax == 0) || (this.female_pax + this.male_pax) > 4) {
                    this.female_pax = 1;
                    this.male_pax = 0;
                }
            }
            else if (pax) {
                if (pax_regex.test(pax)) {
                    this.pax = parseInt(pax);
                }
            }

            if (session) {
                const session_regex = /^(60|90|120)$/;

                if (session_regex.test(session)) {
                    this.session = parseInt(session);
                    this.view_time_onload = true;
                }
            }

            if (experience_tier) {
                const experience_tier_regex = /^(0|1|2)$/;

                if (experience_tier_regex.test(experience_tier)) {
                    this.experience_tier = parseInt(experience_tier);
                }
            }

            if (date_str) {
                const regex = /^\d{4}-\d{2}-\d{2}$/;

                if (regex.test(date_str)) {
                    const date = new Date(date_str);

                    if (!isNaN(date.getTime())) {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const max_date = new Date(today);
                        max_date.setDate(today.getDate() + 30);

                        const input_date = new Date(date);
                        input_date.setHours(0, 0, 0, 0);

                        if (input_date >= today && input_date <= max_date) {
                            this.booking_date = input_date;
                        }
                    }
                }
            }

            if (this.datepickerInstance) {
                this.datepickerInstance.destroy();
            }
            
            this.datepickerInstance = new AirDatepicker(this.$refs.datepickerInput, {
                position: 'bottom center',
                minDate: this.min_date,
                maxDate: this.max_date,
                selectedDates: [this.booking_date],
                keyboardNav: false,
                dateFormat: 'E, MMM d, yyyy',
                autoClose: true,
                toggleSelected: false,
                isMobile: true,
                buttons: [{
                    content: 'Today',
                    onClick: (dp) => {
                        const today = new Date();
                        dp.update({ viewDate: today });
                        dp.selectDate(today);
                    }
                }],
                locale: {
                    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    today: 'Today',
                    clear: 'Clear',
                    firstDay: 0  // 0 = Sunday, 1 = Monday
                },
                onSelect: ({date}) => {
                    this.booking_date = date;
                }
            });
        },
        async get_outlet_info() {
            const params = new URLSearchParams(window.location.search)
            const outlet = params.get("outlet")

            return new Promise((resolve, reject) => {
                frappe.call({
                    method: "healthland_pos.booking.get_outlet_info",
                    args: {
                        key: outlet,
                        flexi_reschedule_id: this.flexi_reschedule_id,
                    },
                    callback: (r) => {
                        this.outlet_options = r.outlet_options;
                        this.outlet = r.outlet_info.name;
                        this.outlet_info = r.outlet_info;
                        this.banner_images = r.banner_images || [];
                        resolve(r);
                    }
                })
            });
        },
        async get_flexi_reschedule_details() {
            const params = new URLSearchParams(window.location.search)
            const flexi_reschedule_id = params.get("flexi_reschedule_id")

            if (flexi_reschedule_id) {
                return new Promise((resolve, reject) => {
                    frappe.call({
                        method: "healthland_pos.booking.get_flexi_reschedule_details",
                        args: {
                            flexi_reschedule_id: flexi_reschedule_id,
                        },
                        callback: (r) => {
                            this.flexi_reschedule_id = r.flexi_reschedule_id;
                            this.total_flexi_reschedule_fee = r.total_flexi_reschedule_fee;
                            this.previously_paid = r.previously_paid;
                            this.previously_paid_with_tax = r.previously_paid_with_tax;
                            resolve(r);
                        }
                    })
                });
            }
        },
        timeslot_on_click(slot, index) {
            if (!slot.active) return;
            this.active_slot = index;

            // Track AddToCart event when timeslot is selected
            const totalValue = this.calculate_total_after_discount_and_tax();
            const itemName = `${this.session} mins Massage - ${this.outlet_info.shop_full_name}`;

            window.dataLayer.push({
                event: 'add_timeslot',
                item_name: itemName,
                value: totalValue,
                currency: 'MYR',
                outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || '',
                session_duration: this.session,
                pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                timeslot: slot.time,
                user_id: this.hashed_user_id,
            });

            // Set abandonment tracking flag
            this.timeslot_selected = true;
            this.timeslot_selected_time = Date.now();

            setTimeout(() => {
                this.$nextTick(() => {
                    document.getElementById("page-bottom")?.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                });
            }, 50);
        },
        format_to_12_hour(time_str) {
            let [h, m] = time_str.split(":");
            h = parseInt(h, 10);

            const suffix = h >= 12 ? "pm" : "am";
            h = (h % 12) || 12; // convert to 12-hour

            return `${h}.${m}${suffix}`;
        },
        format_checkout_time() {
            if (this.active_slot == undefined) {
                return "-";
            }
            return this.format_to_12_hour(this.available_timeslots[this.active_slot].time);
        },
        pretty_date(input) {
            const date = new Date(input);

            const day = date.getDate();

            const monthNames = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            const month = monthNames[date.getMonth()];

            const dayNames = [
                "Sun", "Mon", "Tue", "Wed",
                "Thu", "Fri", "Sat"
            ];

            const weekday = dayNames[date.getDay()];

            return `${day} ${month} (${weekday})`;
        },
        get_discount_percentage(discount) {
            if (discount >= 60) {
                return "discount-percentage-red";
            }
            if (discount >= 40) {
                return "discount-percentage-purple";
            }
            if (discount >= 20) {
                return "discount-percentage-pink";
            }
            return "discount-percentage-pink";
        },
        get_discount_off(discount) {
            if (discount >= 60) {
                return "off-red";
            }
            if (discount >= 40) {
                return "off-purple";
            }
            if (discount >= 20) {
                return "off-pink";
            }
            return "off-pink";
        },
        adjust_session(type) {
            const oldSession = this.session;
            if (type == "reset") {
                this.session = 60;
                this.trigger_pulse("minutes-display");
            }
            else if (type == "add") {
                if (this.session < 120) {
                    this.session += 30;
                    this.trigger_pulse("minutes-display");
                }
            }

            if (oldSession !== this.session) {
                window.dataLayer.push({
                    event: 'session_duration_selection',
                    session_duration: this.session,
                    outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || 'unknown',
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    user_id: this.hashed_user_id,
                });
            }
        },
        adjust_pax(type) {
            const oldPax = this.pax;
            if (type == "minus") {
                if (this.pax > 1) {
                    this.pax -= 1;
                    this.trigger_pulse("pax-display");
                }
            }
            else if (type == "add") {
                if (this.pax < 4) {
                    this.pax += 1;
                    this.trigger_pulse("pax-display");
                }
            }

            if (oldPax !== this.pax) {
                window.dataLayer.push({
                    event: 'pax_selection',
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || 'unknown',
                    session_duration: this.session,
                    user_id: this.hashed_user_id,
                });
            }
        },
        adjust_female_pax(type) {
            if (type == "minus") {
                if (this.female_pax > 0) {
                    this.female_pax -= 1;
                    this.trigger_pulse("female-pax-display");
                    if (this.female_pax == 0 && this.male_pax == 0) {
                        this.male_pax += 1;
                        this.trigger_pulse("male-pax-display");
                    }
                }
            }
            else if (type == "add") {
                if (this.female_pax + this.male_pax < 4) {
                    this.female_pax += 1;
                    this.trigger_pulse("female-pax-display");
                }
            }
        },
        adjust_male_pax(type) {
            if (type == "minus") {
                if (this.male_pax > 0) {
                    this.male_pax -= 1;
                    this.trigger_pulse("male-pax-display");
                    if (this.male_pax == 0 && this.female_pax == 0) {
                        this.female_pax += 1;
                        this.trigger_pulse("female-pax-display");
                    }
                }
            }
            else if (type == "add") {
                if (this.female_pax + this.male_pax < 4) {
                    this.male_pax += 1;
                    this.trigger_pulse("male-pax-display");
                }
            }
        },
        trigger_pulse(id) {
            const dom = document.getElementById(id);
            dom.style.animation = "none";
            void dom.offsetWidth; // reflow, so it replays even on rapid clicks
            dom.style.animation = "pulseUp 0.25s ease-out";
        },
        toggle_therapist_gender_mode(therapist_gender_mode) {
            this.therapist_gender_mode = therapist_gender_mode;
            if (therapist_gender_mode == "auto") {
                this.pax = this.female_pax + this.male_pax;
            }
            else {
                this.female_pax = this.pax - this.male_pax;
                if (this.female_pax < 0) {
                    this.male_pax += this.female_pax;
                    this.female_pax = 0;
                }
            }
        },
        get_online_booking_available_timeslot() {
            if (!this.outlet_info.name) {
                return
            }
            frappe.call({
                method: "healthland_pos.booking.get_online_booking_available_timeslot",
                args: {
                    outlet: this.outlet_info.name,
                    booking_date: this.booking_date.toLocaleDateString("en-CA"),
                    session: this.session,
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    male_pax: this.therapist_gender_mode == "auto" ? 0 : this.male_pax,
                    female_pax: this.therapist_gender_mode == "auto" ? 0 : this.female_pax,
                    flexi_reschedule_id: this.flexi_reschedule_id,
                    experience: this.experience_map[this.experience_tier] || "Standard",
                },
                btn: $("#btn-view-time-now"),
                callback: (r) => {
                    this.price = r.price;
                    this.has_sst = r.has_sst;

                    window.dataLayer.push({
                        event: 'outlet_selected',
                        outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || '',
                        user_id: this.hashed_user_id,
                    });
                    window.dataLayer.push({
                        event: 'timeslot_search',
                        pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                        session_duration: this.session,
                        booking_date: this.booking_date ? this.booking_date.toLocaleDateString('en-CA') : '',
                        outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || '',
                        user_id: this.hashed_user_id,
                    });

                    this.timeslots = this.timeslots.map(slot => {
                        const match = r.online_slot_discount.find(d => d.timeslot === slot.time);

                        return {
                            ...slot,
                            // if match exists → use match.discount
                            // if no match → keep slot.discount unchanged
                            discount: match ? match.discount : slot.discount
                        };
                    });

                    const response_timeslots = new Set(
                        r.available_slots.map(r => r.timeslot)
                    );
                    const available_timeslots = this.timeslots.map(t => ({
                        ...t,
                        active: response_timeslots.has(t.time)
                    }));

                    // Show all timeslots immediately (no stagger animation)
                    this.available_timeslots = available_timeslots;
                    this.display_timeslots = true;

                    this.nearby_outlet = r.nearby_outlet.filter(item => item.is_integrated === 0);
                    this.nearby_outlet_integrated = r.nearby_outlet.filter(item => item.is_integrated === 1);
                    this.next_day = r.next_day;
                    this.next_week = r.next_week;

                    // Scroll into view
                    this.$nextTick(() => {
                        if (this.scroll_to_timeslots) {
                            document.getElementById("view-time-now")?.scrollIntoView({
                                behavior: "smooth",
                                block: "start"
                            });
                        }
                        else {
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                        }
                        this.scroll_to_timeslots = true;
                    });
                }
            })
        },
        nearby_outlet_view_now_onclick(nearby_outlet) {
            if (nearby_outlet.is_integrated) {
                let pax_param = this.therapist_gender_mode == "auto" ? `&pax=${this.pax}` : `&female_pax=${this.female_pax}&male_pax=${this.male_pax}`;
                window.open(`${nearby_outlet.site_url}/booking?outlet=${nearby_outlet.booking_url}&date=${this.booking_date.toLocaleDateString("en-CA")}${pax_param}&session=${this.session}&tier=${this.experience_tier}`, "_blank");
            }
            else {
                this.outlet = nearby_outlet.outlet;
                this.on_outlet_change();
                this.display_outlet_and_date_toast();
                this.scroll_to_timeslots = false;
                this.get_online_booking_available_timeslot();
            }
        },
        next_day_next_week_view_now_onclick(booking_date) {
            const input_date = new Date(booking_date);
            input_date.setHours(0, 0, 0, 0);
            this.booking_date = input_date;
            this.display_outlet_and_date_toast();
            this.scroll_to_timeslots = false;
            this.get_online_booking_available_timeslot();
        },
        on_outlet_change() {
            const oldOutlet = this.outlet_info.name;
            this.clear_active_slots_and_hide_timeslots();
            const selected = this.outlet_options.find(o => o.name === this.outlet);
            this.outlet_info = selected || {};

            const videoFields = ["master_video"];            
            const imageFields = [
                "master_image", "exterior_image", "welcome_area_image",
                "others_image_1", "others_image_2", "others_image_3", "others_image_4",
                "others_image_5", "others_image_6", "others_image_7"
            ];
            const bannerImages = [];

            for (const field of videoFields) {
                if (selected && selected[field]) {
                    bannerImages.push({
                        type: "video",
                        url: selected[field],
                        title: ""
                    });
                }
            }

            for (const field of imageFields) {
                if (selected && selected[field]) {
                    bannerImages.push({
                        type: "image",
                        url: selected[field],
                        title: ""
                    });
                }
            }

            this.banner_images = bannerImages;

            if (selected && oldOutlet !== selected.name) {
                window.dataLayer.push({
                    event: 'outlet_selection',
                    outlet_name: selected.shop_full_name || selected.name,
                    session_duration: this.session,
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    user_id: this.hashed_user_id,
                });
            }
        },
        clear_active_slots_and_hide_timeslots() {
            this.active_slot = undefined;
            this.display_timeslots = false;
            this.price = 999;
        },
        get_discount_rate() {
            const slot = this.available_timeslots[this.active_slot];
            return slot ? slot.discount : 0;
        },
        calculate_total_before_discount() {
            return flt(this.price * (this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax), 2);
        },
        calculate_total_discount() {
            return flt(flt(this.price * (this.get_discount_rate() / 100), 2) * (this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax), 2);
        },
        calculate_subtotal() {
            const total = this.calculate_total_before_discount() - this.calculate_total_discount();
            const total_tax = this.calculate_total_tax_without_flexi_reschedule_fee();
            return flt(total + total_tax, 2);
        },
        calculate_to_top_up() {
            const tax_rate = this.has_sst ? 8 : 0;
            let total = this.calculate_total_before_discount() - this.calculate_total_discount() - (this.flexi_reschedule_id ? this.previously_paid : 0);
            if (total < 0) {
                total = 0;
            }
            const total_tax = total * flt(tax_rate / 100);
            const total_after_discount_and_tax = total + total_tax;
            return flt(total_after_discount_and_tax, 2);
        },
        calculate_total_flexi_reschedule_fee_after_tax() {
            const tax_rate = this.has_sst ? 8 : 0;
            const flexi_schedule_fee = this.flexi_reschedule_id ? this.total_flexi_reschedule_fee : 0;
            const total_tax = flexi_schedule_fee * flt(tax_rate / 100);
            return flt(flexi_schedule_fee + total_tax, 2);
        },
        calculate_total_after_discount_and_tax() {
            const tax_rate = this.has_sst ? 8 : 0;
            const flexi_schedule_fee = this.flexi_reschedule_id ? this.total_flexi_reschedule_fee : 0;
            let total = this.calculate_total_before_discount() - this.calculate_total_discount() - (this.flexi_reschedule_id ? this.previously_paid : 0);
            if (total < 0) {
                total = 0;
            }
            total = total + flexi_schedule_fee;
            const total_tax = total * flt(tax_rate / 100);
            const total_after_discount_and_tax = total + total_tax;
            return flt(total_after_discount_and_tax, 2);
        },
        calculate_total_tax_without_flexi_reschedule_fee() {
            const tax_rate = this.has_sst ? 8 : 0;
            const total = this.calculate_total_before_discount() - this.calculate_total_discount();
            const total_tax = total * flt(tax_rate / 100);
            return flt(total_tax, 2);
        },
        get_session_price() {
            return format_currency(this.price, "RM");
        },
        get_total_before_discount() {
            return format_currency(this.calculate_total_before_discount(), "RM");
        },
        get_total_discount() {
            return format_currency(this.calculate_total_discount(), "RM");
        },
        get_total_after_discount_and_tax() {
            return format_currency(this.calculate_total_after_discount_and_tax(), "RM");
        },
        get_total_tax_without_flexi_reschedule_fee() {
            return format_currency(this.calculate_total_tax_without_flexi_reschedule_fee(), "RM");
        },
        get_subtotal() {
            return format_currency(this.calculate_subtotal(), "RM");
        },
        get_previously_paid() {
            return format_currency(this.has_sst ? this.previously_paid_with_tax : this.previously_paid, "RM");
        },
        get_to_top_up() {
            return format_currency(this.calculate_to_top_up(), "RM");
        },
        get_total_flexi_reschedule_fee() {
            return format_currency(this.calculate_total_flexi_reschedule_fee_after_tax(), "RM");
        },
        checkout_now_onclick() {
            if (this.active_slot === undefined) {
                frappe.throw(__("Please select a timeslot first."));
            }
            this.display_checkout_confirmation = true;
        },
        reconsider_onclick() {
            this.display_checkout_confirmation = false;

            // Track Reconsider/Checkout Abandonment event
            window.dataLayer.push({
                event: 'checkout_reconsider',
                user_id: this.hashed_user_id,
            });
        },
        ok_lets_go_onclick() {
            const slot = this.available_timeslots[this.active_slot];
            window.dataLayer.push({
                event: 'initiate_checkout',
                value: this.calculate_total_after_discount_and_tax(),
                outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || '',
                timeslot: slot?.time || '',
                timeslot_formatted: slot ? this.format_to_12_hour(slot.time) : '',
                user_id: this.hashed_user_id,
            });
            this.checkout();
        },
        checkout() {
            // Clear abandonment tracking since user is completing checkout
            this.timeslot_selected = false;

            frappe.call({
                method: "healthland_pos.booking.checkout",
                args: {
                    outlet: this.outlet_info.name,
                    booking_date: this.booking_date.toLocaleDateString("en-CA"),
                    session: this.session,
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    male_pax: this.therapist_gender_mode == "auto" ? 0 : this.male_pax,
                    female_pax: this.therapist_gender_mode == "auto" ? 0 : this.female_pax,
                    timeslot: this.available_timeslots[this.active_slot].time,
                    flexi_reschedule_id: this.flexi_reschedule_id,
                    experience: this.experience_map[this.experience_tier] || "Standard",
                    tracking_ids: get_tracking_ids(),
                },
                btn: $("#btn-ok-lets-go"),
                callback: (r) => {
                    if (r.success) {
                        window.location.replace(r.redirect_url);
                    }
                    else {
                        if (r.flexi_reschedule_expired) {
                            window.location.replace("/flexi-reschedule");
                        }
                        else {
                            frappe.msgprint(r.message);
                        }
                    }
                    this.active_slot = undefined;
                    this.display_timeslots = false;
                    this.display_checkout_confirmation = false;
                }
            })
        },
        openWaze() {
            window.open(this.outlet_info.waze, '_blank');
        },
        toggleVideo(event) {
            const video = event.currentTarget.querySelector('video');
            const btn = event.currentTarget.querySelector('.video-play-btn');
            if (video.paused) {
                video.play();
                btn.style.display = 'none';
            } else {
                video.pause();
                btn.style.display = 'flex';
            }
        },
        scrollToMoreDiscount() {
            this.$nextTick(() => {
                const el = document.getElementById("more-discount-row");

                if (el) {
                    const offset = 20; // adjust this (e.g. sticky header height)
                    const top = el.getBoundingClientRect().top + window.scrollY - offset;

                    window.scrollTo({
                        top,
                        behavior: "smooth"
                    });
                }
            });
        },
        checkMoreDiscountVisibility() {
            const target = document.getElementById("suggetion-div-end");
            const floating = document.getElementById("floating-more-discount-row");

            if (!target || !floating) return;

            const rect = target.getBoundingClientRect();

            const isVisible =
                rect.top < window.innerHeight &&
                rect.bottom > 0;

            floating.style.display = isVisible ? "none" : "flex";

            // if NOT visible → show once
            if (isVisible) {
                this.show_floating_more_discount = false;
                window.removeEventListener("scroll", this.checkMoreDiscountVisibility);
                window.removeEventListener("resize", this.checkMoreDiscountVisibility);
            }
        },
        add_toast(message, timeout=5000) {
            const id = this.toast_id++;

            this.toasts.push({
                id,
                message
            });

            setTimeout(() => {
                const index = this.toasts.findIndex(t => t.id === id);
                if (index !== -1) {
                    this.toasts.splice(index, 1);
                }
            }, timeout);
        },
        display_outlet_and_date_toast() {
            if (this.outlet_info.shop_full_name && this.booking_date) {
                this.add_toast(`
                    <span>
                        Currently viewing&nbsp;
                        <span style="font-weight: 900;">${this.outlet_info.shop_full_name}</span>
                        ,&nbsp;for
                        <span style="font-weight: 900;">${this.pretty_date(this.booking_date)}</span>
                    </span>`
                );
            }
        },
        track_booking_abandonment() {
            if (this.timeslot_selected && this.active_slot !== undefined) {
                const slot = this.available_timeslots[this.active_slot];
                const timeOnPage = this.timeslot_selected_time ? Math.floor((Date.now() - this.timeslot_selected_time) / 1000) : 0;
                const totalValue = this.calculate_total_after_discount_and_tax();
                const discountPercent = slot ? (slot.discount || 0) : 0;

                window.dataLayer.push({
                    event: 'booking_abandonment',
                    outlet_name: this.outlet_info?.shop_full_name || this.outlet_info?.name || 'unknown',
                    session_duration: this.session,
                    pax: this.therapist_gender_mode == "auto" ? this.pax : this.female_pax + this.male_pax,
                    timeslot: slot ? slot.time : 'unknown',
                    discount_percentage: discountPercent,
                    value: totalValue,
                    currency: 'MYR',
                    time_on_page_seconds: timeOnPage,
                    user_id: this.hashed_user_id,
                });
            }
        },
        async get_hashed_user_id() {
            if (
                typeof frappe === 'undefined' ||
                !frappe.session ||
                !frappe.session.user ||
                frappe.session.user === 'Guest'
            ) {
                return undefined;
            }

            const user_id = frappe.session.user.toLowerCase().trim();
            const encoder = new TextEncoder();
            const data = encoder.encode(user_id);
            const hashBuffer = await crypto.subtle.digest("SHA-256", data);

            return Array.from(new Uint8Array(hashBuffer))
                .map((b) => b.toString(16).padStart(2, "0"))
                .join("");
        }
    },
    async created() {
        this.hashed_user_id = await this.get_hashed_user_id();
    },
    async mounted() {
        await this.get_flexi_reschedule_details();
        await this.get_outlet_info();
        
        this.$nextTick(() => {
            this.initDatepicker();
            if (this.view_time_onload) {
                this.display_outlet_and_date_toast();
                this.scroll_to_timeslots = false;
                this.get_online_booking_available_timeslot();
            }
        });

        $('#homeCarouse').on('slide.bs.carousel', function () {
            $('.carousel-item video').each(function() {
                this.pause();
            });
        });

        window.addEventListener("scroll", this.checkMoreDiscountVisibility);
        window.addEventListener("resize", this.checkMoreDiscountVisibility);

        // Track booking abandonment when user leaves page
        window.addEventListener('beforeunload', () => {
            this.track_booking_abandonment();
        });

        // Also track when user navigates away (SPA navigation)
        window.addEventListener('pagehide', () => {
            this.track_booking_abandonment();
        });
    },
    beforeUnmount() {
        if (this.datepickerInstance) {
            this.datepickerInstance.destroy();
        }
        // Track abandonment when component is destroyed
        this.track_booking_abandonment();
    }
}
</script>

<style scoped>
#main {
    width: 100vw;
    max-width: 380px;
    overflow-x: hidden;
    font-family: "Custom Arial Black", sans-serif;
    user-select: none;
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none;    /* Firefox (legacy, rarely needed now) */
    -ms-user-select: none;     /* old Edge/IE */
}

.carousel-item {
    max-height: 380px; /* Adjust the carousel height */
    transition: none !important;
}

#reschedule-banner {
    max-width: 380px;
    background-color: #8140E3;
}

#reschedule-msg-bg {
    color: white;
    font-weight: bold;
    font-size: 16px;
}

#reschedule-msg-sm {
    color: white;
    font-weight: bold;
    font-size: 10px;
}

#reschedule-banner img {
    width: auto;
    height: 50px;
}

.carouselbar {
    padding-bottom: 0;
    max-width: 380px;
    background-color: #E89D74;
}

.carousel-control-next,
.carousel-control-prev {
    height: 20%;
    top: 50%;
    transform: translateY(-50%);
}

#img-outlet-container {
    border: 3px solid #BB7927;
    border-radius: 15%;
}

#img-outlet {
    border: 8px solid #F7BA48;
    border-radius: 15%;
}

#img-outlet img {
    border: 3px solid #BB7927;
    border-radius: 12%;
}

.timeslot {
    background-color: #FDDEAF;
    border: 3px solid #AF805E;
    border-radius: 18%;
    aspect-ratio: 1;
    cursor: pointer;
    font-family: "Winter Minie", sans-serif;
}

.timeslot-active {
    background-color: #91FF00;
}

.time {
    font-size: 20px;
    color: #3E1D00;
}

.discount-percentage-red {
    font-size: 24px;
    font-weight: bold;
    color: #E35B47;
    margin-top: -8px;
    margin-bottom: -8px;
}

.off-red {
    font-size: 10px;
    font-weight: bold;
    color: #E35B47;
}

.discount-percentage-purple {
    font-size: 24px;
    font-weight: bold;
    color: #B87AD1;
    margin-top: -8px;
    margin-bottom: -8px;
}

.off-purple {
    font-size: 10px;
    font-weight: bold;
    color: #B87AD1;
}

.discount-percentage-pink {
    font-size: 24px;
    font-weight: bold;
    color: #EB7EC1;
    margin-top: -8px;
    margin-bottom: -8px;
}

.off-pink {
    font-size: 10px;
    font-weight: bold;
    color: #EB7EC1;
}

#soma-logo {
    width: 95%;
    height: auto;
}

#powered-by {
    width: 95%;
    height: auto;
}

#btn-view-time-now {
    width: 100%;
    border: 0;
    background: none;
    padding: 0;
}

#btn-view-time-now:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

#view-time-now {
    width: 100%;
    height: auto;
}

@keyframes jump {
    0% {
        transform: translateY(0);
    }

    10% {
        transform: translateY(-12px);
    }

    20% {
        transform: translateY(0);
    }

    30% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(0);
    }
}

#floating-more-discount-row {
    position: fixed;
    width: 100vw;
    max-width: 380px;
    bottom: 40px;
    z-index: 998;
    cursor: pointer;
    animation: jump 2s ease infinite;
}

#more-discount-row {
    position: relative;
}

#more-discount {
    background-color: #3885fb;
    color: #fff;
    border-radius: 20px;
    border: 3px solid #fff;
    font-size: 18px;
}

.suggested-outlet-row {
    border-radius: 15px;
    position: relative;
    background-color: #fff;
    border: 5px solid #ad815b;
}

.nearby-outlet-title {
    font-size: 18px;
    color: #85c5ed;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
}

.nearby-outlet-title img {
    width: 80px;
    height: auto;
}

#same-outlet-title-nd {
    font-size: 18px;
    color: #ee8aa5;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
}

#same-outlet-title-nw {
    font-size: 18px;
    color: #7cc06d;
    background-color: #fff;
    border-radius: 10px 10px 0 0;
}

.nearby-outlet-content {
    font-size: 16px;
    color: #fff;
    background-color: #85c5ed;
    border-top: 5px solid #ad815b;
    border-radius: 0px 0px 10px 10px;
}

.same-outlet-content {
    font-size: 16px;
    color: #fff;
    background-color: #ee8aa5;
    border-top: 5px solid #ad815b;
    border-radius: 0px 0px 10px 10px;
}

.same-outlet-content-nw {
    background-color: #7cc06d;
}

.nearby-outlet-content-no-title {
    border: 0px;
    border-radius: 10px 10px 10px 10px;
}

.shop-full-name {
    font-size: 14px;
    font-family: "Custom Arial", sans-serif;
    line-height: 1.3;
}

.btn-view-now {
    position: absolute;
    font-size: 15px;
    color: #fff;
    background-color: #ff8b43;
    border: 3px solid #ad815b;
    border-radius: 15px;
    width: 80%;
    bottom: -35%;
    left: 6px;
}

.distant {
    font-size: 40px;
    line-height: 1.1;
}

.distant-label {
    font-size: 10px;
    line-height: 1;
    letter-spacing: -0.5px;
    transform: scaleY(1.5);
}

.up-to-label {
    color: #FFF601;
    font-size: 10px;
    line-height: 1;
    font-weight: bold;
}

.highest-discount {
    color: #FFF601;
    font-size: 60px;
    line-height: 0.8;
}

.highest-discount-label {
    color: #FFF601;
    font-size: 15px;
    line-height: 1;
}

#checkout-now {
    width: 100%;
    height: auto;
    cursor: pointer;
}

.booking-icon {
    width: 25px;
    height: auto;
}

.booking-info {
    color: #9E602C;
    font-size: 18px;
    transform: scaleX(1.1);
    font-family: "Custom Arial", sans-serif;
    font-weight: bold;
}

#discount-info, #previously-paid-info {
    color: #FFF601;
}

#img-nearby-outlet {
    position: absolute;
    padding: 0px;
    width: 40%;
    height: auto;
    right: 0;
    margin-top: -6%;
    z-index: 1;
}

#booking-total {
    color: black;
}

#select-outlet-outer-container {
    border: 3px solid #BB7927;
    border-radius: 16px;
    padding: 6px;
    background-color: #F7BA48;
}

#select-outlet-container {
    border: 3px solid #BB7927;
    border-radius: 10px;
    padding: 5px 7px 5px 7px;
    background-color: #EE993D;
}

#select-outlet-container img {
    width: 25px;
    height: auto;
}

#select-outlet {
    border: none;
    background-color: transparent;
    color: #FECF6B;
    font-size: 20px;
}

select:focus {
    outline: none;
    border: none;
    box-shadow: none;
}

#address-outer-container {
    border: 3px solid #BB7927;
    border-radius: 16px;
    padding: 6px;
    background-color: #F7BA48;
}

#address-container {
    border: 3px solid #BB7927;
    border-radius: 10px;
    background-color: #EE993D;
    padding: 8px 12px;
}

.address-text {
    font-size: 14px;
    color: #FECF6B;
    word-break: break-word;
    flex-shrink: 1;
    min-width: 0;
}

.waze-btn {
    cursor: pointer;
    flex-shrink: 0;
}

#session-outer-container {
    border: 3px solid #BB7927;
    border-radius: 16px;
    padding: 6px;
    background-color: #F7BA48;
}

#session-container {
    border: 3px solid #BB7927;
    border-radius: 10px;
    background-color: #EE993D;
    color: #FECF6B;
    padding: 3px 0px 3px 0px;
}

#session-container img {
    width: 20px;
    height: auto;
    transform: scaleY(0.8);
}

#minutes-display {
    font-size: 17px;
    line-height: 1.0;
}

#minutes {
    font-size: 10px;
}

#pax-outer-container, #therapist-gender-outer-container {
    border: 3px solid #BB7927;
    border-radius: 16px;
    padding: 6px;
    background-color: #F7BA48;
}

#pax-outer-container {
    overflow: hidden;
}

#pax-track-outer {
    width: 200%;
    transition: transform 0.35s ease-in-out;
}

.pax-track-inner {
    width: 50%;
}

#pax-container-auto {
    border: 3px solid #BB7927;
    border-radius: 10px;
    background-color: #EE993D;
    color: #FECF6B;
    padding: 2.5px 0px 2.5px 0px;
}

#pax-container-specific {
    border: 3px solid #BB7927;
    border-radius: 10px;
    background-color: #EE993D;
    color: #FECF6B;
}

#pax-container-specific > div {
    padding: 2.5px 0px 2.5px 0px;
}

#male-pax-container {
    border-left: 3px solid #BB7927;
}

#therapist-gender-container {
    border: 3px solid #BB7927;
    border-radius: 10px;
    background-color: #EE993D;
    color: #FECF6B;
    padding: 5px 0px 5px 0px;
}

#therapist-gender-container {
    cursor: pointer;
}

#therapist-gender-female, #therapist-gender-male {
    width: auto;
    height: 25px;
}

#therapist-gender-back {
    width: auto;
    height: 25px;
}

#pax-container-auto img, #pax-container-specific img {
    width: 20px;
    height: auto;
}

#label-any-therapist {
    font-size: 10px;
}

#pax-display, #female-pax-display, #male-pax-display {
    font-size: 17px;
    line-height: 1.0;
}

.btn-adjust-session {
    font-size: 20px;
    line-height: 1.0;
    cursor: pointer;
    color: #BB7927;
    background-color: #FECF6B;
    border: 3px solid #BB7927;
    border-radius: 50%;
}

.btn-adjust-pax {
    font-size: 20px;
    line-height: 0.85;
    cursor: pointer;
    color: #BB7927;
    background-color: #FECF6B;
    border: 3px solid #BB7927;
    border-radius: 50%;
}

#date-outer-container {
    border: 3px solid #BB7927;
    border-radius: 16px;
    padding: 6px;
    background-color: #F7BA48;
}

#date-container {
    border: 3px solid #BB7927;
    border-radius: 10px;
    background-color: #EE993D;
    color: #FECF6B;
    font-size: 20px;
}

#date-container img {
    width: 35px;
    height: auto;
}

.timeslot-unavailable {
    opacity: .65;
    cursor: not-allowed;
}

/* Smooth hover effect for timeslots */
.timeslot {
    transition: all 0.3s ease;
}

.timeslot:hover:not(.timeslot-unavailable) {
    transform: translateY(-3px) scale(1.05);
    box-shadow: 0 6px 16px rgba(187, 121, 39, 0.4);
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.popup {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100vw;
    max-width: 380px;
    height: auto;
    transform: translate(-50%, -50%);
    z-index: 1000;
}

.popup img {
    width: 100%;
    height: auto;
}

#popup-btn-row {
    position: absolute;
    bottom: 50px;
}

.popup-btn {
    cursor: pointer;
}

#btn-ok-lets-go {
    width: 100%;
    border: 0;
    background: none;
    padding: 0;
}

#btn-ok-lets-go:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Slide Down Animation */
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.5s ease-out;
    max-height: 1000px; /* Safe upper limit for content height */
    opacity: 1;
    overflow: hidden;
}

.slide-down-enter-from,
.slide-down-leave-to {
    max-height: 0;
    opacity: 0;
    margin-top: 0 !important; /* Ensure margin doesn't jump */
}

#booking-date {
    cursor: pointer;
}

#booking_date_datepicker {
    background-color: transparent;
    border: none;
    box-shadow: none;
    width: 100%;
    text-align: center;
    padding-bottom: 0px;
    color: #FECF6B;
    font-size: 17px;
    cursor: pointer;
}

#booking_date_datepicker:focus {
    outline: none;
    border: none;
}

.carousel-item img {
    border-radius: 0px;
}

.carousel-item video {
    border-radius: 0px;
}

.video-wrapper {
    position: relative;
    cursor: pointer;
}

.video-play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
    background: rgba(0,0,0,0.6);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 30px;
    pointer-events: none;
}

.toast-item {
    padding: 5px 10px 5px 10px;
    border-radius: 5px;
    background: #009cff;
    width: 350px;
    z-index: 998;
    color: #fff;
}

.toast-wrapper {
    position: absolute;
    top: 100%; /* directly below navbar */
    left: 50%;
    transform: translateX(-50%);
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-end;
}

/* ENTER: fade + come down */
.toast-enter-active {
    transition: all 0.3s ease-out;
}

.toast-enter-from {
    opacity: 0;
    transform: translateY(-10px);
}

.toast-enter-to {
    opacity: 1;
    transform: translateY(0);
}

/* LEAVE: fade + go up */
.toast-leave-active {
    transition: all 0.3s ease-out;
}

.toast-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

/* smooth reflow */
.toast-move {
    transition: transform 0.3s ease;
}

@media screen and (max-width: 576px) {
    #main {
        max-width: none;
    }
    #floating-more-discount-row {
        max-width: none;
    }
    #reschedule-banner {
        max-width: none;
    }
    .carouselbar {
        max-width: none;
    }
    .time {
        font-size: 24px;
    }
    #more-discount {
        font-size: 20px;
    }
    .nearby-outlet-title {
        font-size: 20px;
    }
    #same-outlet-title-nd {
        font-size: 20px;
    }
    #same-outlet-title-nw {
        font-size: 20px;
    }
    .nearby-outlet-content {
        font-size: 18px;
    }
    .same-outlet-content {
        font-size: 18px;
    }
    .discount-percentage-pink, .discount-percentage-purple, .discount-percentage-red {
        font-size: 29px;
    }
    .off-pink, .off-purple, .off-red {
        font-size: 12px;
    }
}

.visually-hidden,.visually-hidden-focusable:not(:focus):not(:focus-within) {
    position: absolute!important;
    width: 1px!important;
    height: 1px!important;
    padding: 0!important;
    margin: -1px!important;
    overflow: hidden!important;
    clip: rect(0,0,0,0)!important;
    white-space: nowrap!important;
    border: 0!important
}
</style>